import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getInternalPortalAnnouncements } from "../api/api";
import LayoutBottom from "../Components/Layout/LayoutBottom";
import LayoutTop from "../Components/Layout/LayoutTop";

import AnnouncementSliderComponent from "../Components/Sliders/AnnouncementSliderComponent";


function VacanciesPage() {

  const { t, i18n } = useTranslation();


const { isLoading, error, data, isFetching, refetch }: any = useQuery(
  "HomeSliderData",
  () => getInternalPortalAnnouncements({ limit: 20,table:'vacancies', language: i18n.language })
);


useEffect(() => {
  refetch();
}, [i18n.language]);

if (isLoading) return <div></div>;

if (error) return <div></div>;



  return (
    <>
    <LayoutTop/>


    <div className="wrapper3 wrapper4">
            <div className="container-fluid">
                <h4 className="shape-round mb-lg-5 pb-5">التوظيف</h4>
                <AnnouncementSliderComponent  slides={data.data}/>
                
            </div>
        </div>
        <LayoutBottom/>

    </>
  );
}

export default VacanciesPage;
